// 时钟
export var clock = typeof performance === 'object' && performance.now ? performance : Date;
//# sourceMappingURL=clock.js.map